module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/relatedlink_02-0025a1b8fb69c23c5c35bb23437b5984.jpg";